import { ossUrl, requestUrl } from '@/config/app';

export const defaultSiteLogoURL = `${process.env.BASE_URL}brand-logo.png?v=c58b45`;

export function resolveSiteLogoURL(source, publicBaseURL = 'https://files.jdbsk.com') {
  source = String(source || '').trim();
  if (!source) return defaultSiteLogoURL;
  if (/^https?:\/\//i.test(source)) return source;
  const base = source.startsWith('/static/public/system/')
    ? requestUrl
    : source.startsWith('/public/system/') ? publicBaseURL : ossUrl;
  return `${String(base).replace(/\/$/, '')}/${source.replace(/^\/+/, '')}`;
}

export function setSiteFavicon(source) {
  const link = document.querySelector('link[rel="icon"]') || document.createElement('link');
  link.rel = 'icon';
  link.removeAttribute('type');
  link.href = defaultSiteLogoURL;
  if (!link.parentNode) document.head.appendChild(link);
  if (!source || source === defaultSiteLogoURL) return;
  const image = new Image();
  image.onload = () => { link.href = source; };
  image.src = source;
}
